export default function createDiv({text, api, placeholder, classNames}){
    const classList = classNames.split(" ");
    let div = document.createElement("div");
    div.contentEditable = true;
    div.classList.add("cdx-block", "ce-paragraph", ...[classList]);
    div.dataset.placeholder = api.i18n.t(placeholder);
    div.innerHTML = text || "";
    return div
}